import { createUseStyles } from 'react-jss';
import { theme } from '@align-cpf/uikit-styles';

export default createUseStyles(
  {
    root: {
      borderRadius: 4,
      overflow: 'hidden',
      background: theme.colors.backgroundMenu,
      position: 'relative',
      paddingLeft: 4,
      boxShadow: '0px 2px 12px rgba(0, 0, 0, 0.125);', // TODO: token
      font: theme.typography.tpBody01,
      display: 'inline-flex',

      '&:before': {
        content: '""',
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        width: 4,
        zIndex: 2,
        borderRadius: [2, 0, 0, 2],
      },
    },

    multiline: {
      width: 235,

      '& $content': {
        flexDirection: 'column',
      },

      '& $withLink': {
        marginRight: 0,
      },

      '& $message': {
        marginLeft: 0,
      },
    },

    inline: {
      width: '100%',
      display: 'flex',
      boxShadow: 'unset',

      '& $body:before': {
        content: '""',
        inset: 0,
        pointerEvents: 'none',
        position: 'absolute',
        borderRadius: 4,
        border: '1px solid transparent',
      },

      '&$information $body': {
        background: theme.colors.notificationBackgroundInformation,
      },

      '&$information $body:before': {
        borderColor: theme.colors.notificationBorderInformation,
      },

      '&$success $body': {
        background: theme.colors.notificationBackgroundSuccess,
      },

      '&$success $body:before': {
        borderColor: theme.colors.notificationBorderSuccess,
      },

      '&$warning $body': {
        background: theme.colors.notificationBackgroundWarning,
      },

      '&$warning $body:before': {
        borderColor: theme.colors.notificationBorderWarning,
      },

      '&$error $body': {
        background: theme.colors.notificationBackgroundError,
      },

      '&$error $body:before': {
        borderColor: theme.colors.notificationBorderError,
      },
    },

    body: {
      display: 'flex',
      flexGrow: 1,
      color: theme.colors.textPrimary,
      padding: [theme.spacing.sp03, theme.spacing.sp04],
    },
    icon: {
      marginRight: theme.spacing.sp02,
    },
    content: {
      display: 'flex',
    },

    title: {
      font: theme.typography.tpHeading01,
    },
    message: {
      marginLeft: 2,
      color: theme.colors.textSecondary,
    },
    withLink: {
      marginRight: theme.spacing.sp01,
    },
    close: {
      margin: `calc(0px - ${theme.spacing.sp02})`,
      marginLeft: theme.spacing.sp02,
      padding: theme.spacing.sp02,
      cursor: 'pointer',
      '&:active': {
        transform: 'translateY(1px)',
      },
    },

    information: {
      '& $icon': {
        color: theme.colors.iconLink,
      },

      '&:before': {
        backgroundColor: theme.colors.borderInteractive,
      },
    },
    success: {
      '& $icon': {
        color: theme.colors.iconSuccess,
      },

      '&:before': {
        backgroundColor: theme.colors.borderSuccess,
      },
    },
    warning: {
      '& $icon': {
        color: theme.colors.iconWarning,
      },

      '&:before': {
        backgroundColor: theme.colors.borderWarning,
      },
    },
    error: {
      '& $icon': {
        color: theme.colors.iconError,
      },

      '&:before': {
        backgroundColor: theme.colors.borderError,
      },
    },
  },
  {
    name: 'Notification',
  },
);
